import { API } from '../constants/api';

import { axiosInterceptor } from './interceptors';

export const listTracks = async (payload: any, signal?: any) => {
    const response = await axiosInterceptor.post(API.RADAR.LIST_TRACKS, payload, { signal });

    return response;
};

export const getTrackOrderDetail = (id: string) => axiosInterceptor.get(`${API.TRACK.ORDER_DETAIL}/${id}`);

export const updateTrackTableColumnSettings = async (data: any) => {
    const response = await axiosInterceptor.patch(API.TABLE_COLUMN_SETTINGS.UPDATE, data);

    return response;
};

// Saved views for the Track page (custom_views, tableAlias 'cp_track') — same generic
// /view/* endpoints Orders and Quotes use; see OrderService.ts for the sibling wrappers.
export const getTrackViewList = async (params: { tableAlias: string }) => {
    const response = await axiosInterceptor.get(API.VIEW.LIST, { params });

    return response;
};

export const createTrackView = async (data: any) => {
    const response = await axiosInterceptor.post(API.VIEW.CREATE, data);

    return response;
};

export const updateTrackView = async (id: number | string, data: any) => {
    const response = await axiosInterceptor.patch(`${API.VIEW.UPDATE}/${id}`, data);

    return response;
};

export const deleteTrackView = async (id: number | string) => {
    const response = await axiosInterceptor.delete(`${API.VIEW.DELETE}/${id}`);

    return response;
};
